import { fetchFromDatoProxy } from "lib/cms/dato";
import type { NewsletterVariant } from "lib/types/sitewideOption";

type FetchNewslettersListResponse = {
  sitewideOption: {
    newslettersList: NewsletterVariant[];
  };
};

const fetchNewslettersList = async (): Promise<NewsletterVariant[]> => {
  const data = await fetchFromDatoProxy<FetchNewslettersListResponse>({
    query: `
  query MyQuery {
    sitewideOption {
        newslettersList {
          id
          title
          description
          frequency
          isFeatured
          accent
          buttonVariant
          newsletterType
          cardImage {
            url
            alt
            width
            height
            blurUpThumb
          }
          alreadySignedUpButtonLabel
          buttonLabel
        }
    }
  }
  `,
    urlPath: "/sitewideOptions/newsletters",
  });

  return data?.sitewideOption?.newslettersList || [];
};

export default fetchNewslettersList;
